import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useState } from "react";
import { ConversationSearchBar } from "./ConversationSearchBar";
import { ConversationItem } from "./ConversationItem";

interface Conversation {
  id: string;
  name: string;
  lastMessage: string;
  timestamp: string;
  unread?: boolean;
  source: 'telegram' | 'whatsapp';
}

interface ConversationsListProps {
  conversations: Conversation[];
  selectedConversation: Conversation | null;
  onSelectConversation: (conversation: Conversation) => void;
}

export const ConversationsList = ({
  conversations,
  selectedConversation,
  onSelectConversation,
}: ConversationsListProps) => {
  const [searchQuery, setSearchQuery] = useState("");

  const filteredConversations = conversations.filter((conversation) => {
    const searchLower = searchQuery.toLowerCase();
    return (
      conversation.name.toLowerCase().includes(searchLower) ||
      conversation.lastMessage.toLowerCase().includes(searchLower)
    );
  });

  return (
    <Card className="w-full h-full border-0">
      <CardHeader className="border-b border-gray-100 bg-[#F0F2F5] py-4 space-y-4">
        <CardTitle className="text-lg font-semibold text-[#41525D]">Conversas</CardTitle>
        <ConversationSearchBar
          value={searchQuery}
          onChange={setSearchQuery}
        />
      </CardHeader>
      <CardContent className="p-0">
        <div className="space-y-0 divide-y divide-gray-100">
          {filteredConversations.map((conversation) => (
            <ConversationItem
              key={conversation.id}
              {...conversation}
              isSelected={selectedConversation?.id === conversation.id}
              onClick={() => onSelectConversation(conversation)}
            />
          ))}
        </div>
      </CardContent>
    </Card>
  );
};